import { validationRules } from '../../../../../services/validation/rules/validationRules'
import { ValidationSchema } from '../../../../../@types/validation-types'
import {
  defaultContactInfo,
  defaultDescription,
  useManualAndInternationalAddress,
  usePurchasePriceOnRequestCondition,
} from '../../../../../services/validation/flow/defaultSchemas'

export const propertyOwnerGarageSellSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  basicInfo: {
    constructionYear: validationRules.constructionYear,
    constructionLastModernization: validationRules.constructionLastModernization,
    price: usePurchasePriceOnRequestCondition,
  },
  description: { ...defaultDescription, adFurnishingNote: validationRules.adFurnishingNote },
  contactInfo: defaultContactInfo,
  otherFacilities: {
    heightGarage: validationRules.heightGarage,
    widthGarage: validationRules.widthGarage,
    lengthGarage: validationRules.lengthGarage,
    usableArea: validationRules.usableGarageArea,
  },
}
